/**
 * OpenList 错误状态组件
 */

"use client"

import { Button } from "@/components/ui/button"

interface OpenListErrorStateProps {
  error: string
  onDismiss: () => void
}

export function OpenListErrorState({ error, onDismiss }: OpenListErrorStateProps) {
  // 渲染未配置状态
  if (error.includes("科目未配置 OpenList 路径")) {
    return (
      <div className="text-center py-16">
        <div className="mx-auto max-w-md">
          <svg className="h-16 w-16 mx-auto mb-4 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1-1H8a1 1 0 00-1 1v3M4 7h16" />
          </svg>
          <h3 className="text-lg font-medium text-gray-900 mb-2">资源文件暂未配置</h3>
          <p className="text-gray-600 mb-6">
            此科目的文件资源存储路径尚未配置，无法浏览和下载文件。
          </p>
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 text-left">
            <h4 className="text-sm font-medium text-blue-800 mb-2">如何解决：</h4>
            <ul className="text-sm text-blue-700 space-y-1">
              <li>• 联系管理员为此科目配置 OpenList 存储路径</li>
              <li>• 管理员可在后台管理界面中设置科目的资源路径</li>
            </ul>
          </div>
        </div>
      </div>
    )
  }

  // 渲染一般错误状态
  return (
    <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
      <div className="flex items-start space-x-3">
        <div className="flex-shrink-0">
          <svg className="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
          </svg>
        </div>
        <div className="flex-1">
          <h3 className="text-sm font-medium text-red-800">无法加载文件资源</h3>
          <p className="text-red-600 text-sm mt-1">{error}</p>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={onDismiss}
          className="flex-shrink-0"
        >
          ✕
        </Button>
      </div>
    </div>
  )
}
